webpackJsonp([11,35],{

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(7);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	module.exports = new _vue2.default();

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function (config) {
	  this.distanceX = 0;
	  this.distanceY = 0;
	  this.startPos = [0, 0];
	  this.currentPos = [0, 0];
	  this.startTime = 0;
	  this.endTime = 0;
	  this.speedX = 0;
	  this.speedY = 0;
	
	  this.state = 'FREE';
	  this.alias = config.alias || '';
	  this.dom = config.dom;
	  this.eventType = config.type || 'swipe';
	  this.callback = config.doing || function () {};
	  this.donecallback = config.done || function () {};
	
	  this.mode = config.mode || 'strict';
	
	  var t = this;
	
	  this.handleTouchStart = function (e) {
	    t.startTime = new Date().getTime();
	    t.state = 'START';
	    var touch = e.targetTouches[0];
	    t.startPos = [touch.pageX, touch.pageY];
	
	    t.callback('touchstart', {
	      distance: { x: t.distanceX, y: t.distanceY },
	      position: t.startPos,
	      state: t.state,
	      alias: t.alias
	    });
	  };
	
	  this.handleTouchMove = function (e) {
	    t.state = 'MOVING';
	    var touch = e.targetTouches[0];
	    t.currentPos = [touch.pageX, touch.pageY];
	    t.distanceX = t.currentPos[0] - t.startPos[0];
	    t.distanceY = t.currentPos[1] - t.startPos[1];
	    t.callback('touchmove', {
	      distance: { x: t.distanceX, y: t.distanceY },
	      position: t.currentPos,
	      state: t.state,
	      alias: t.alias
	    });
	  };
	
	  this.handleTouchEnd = function () {
	    t.state = 'END';
	    t.endTime = new Date().getTime();
	    var time = Math.floor((t.endTime - t.startTime) / 1000);
	
	    if (t.currentPos[0] === 0 || t.currentPos[1] === 0) {
	      t.currentPos = t.startPos;
	    }
	
	    t.distanceX = t.currentPos[0] - t.startPos[0];
	    t.distanceY = t.currentPos[1] - t.startPos[1];
	
	    if (time === 0) time = 1;
	    t.speedX = Math.abs(t.distanceX / time);
	    t.speedY = Math.abs(t.distanceY / time);
	
	    if (!t.actions[t.eventType]()) {
	      t.callback('touchend', {
	        distance: { x: t.distanceX, y: t.distanceY },
	        speed: { x: t.speedX, y: t.speedY },
	        position: t.currentPos,
	        state: t.state,
	        alias: t.alias
	      });
	    } else {
	      if (t.mode === 'unstrict') {
	        t.callback('touchend', {
	          distance: { x: t.distanceX, y: t.distanceY },
	          speed: { x: t.speedX, y: t.speedY },
	          position: t.currentPos,
	          state: t.state,
	          alias: t.alias
	        });
	      }
	
	      t.donecallback({
	        distance: { x: t.distanceX, y: t.distanceY },
	        speed: { x: t.speedX, y: t.speedY },
	        position: t.currentPos,
	        state: t.state,
	        alias: t.alias
	      });
	    }
	
	    t.state = 'FREE';
	    t.distanceX = 0;
	    t.distanceY = 0;
	    t.startTime = 0;
	    t.endTime = 0;
	    t.speedX = 0;
	    t.speedY = 0;
	    t.startPos = [0, 0];
	    t.currentPos = [0, 0];
	  };
	
	  this.actions = {
	    swipe: function swipe() {
	      return true;
	    },
	    swipeDown: function swipeDown() {
	      if (t.distanceY > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeUp: function swipeUp() {
	      if (t.distanceY < -60) {
	        return true;
	      }
	      return false;
	    },
	    swipeLeft: function swipeLeft() {
	      if (t.distanceX < -60) {
	        return true;
	      }
	      return false;
	    },
	    swipeRight: function swipeRight() {
	      if (t.distanceX > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeX: function swipeX() {
	      if (Math.abs(t.distanceX) > 60) {
	        return true;
	      }
	      return false;
	    },
	    swipeY: function swipeY() {
	      if (Math.abs(t.distanceY) > 60) {
	        return true;
	      }
	      return false;
	    }
	  };
	
	  this.init = function () {
	    this.dom.addEventListener('touchstart', this.handleTouchStart);
	    this.dom.addEventListener('touchmove', this.handleTouchMove);
	    this.dom.addEventListener('touchend', this.handleTouchEnd);
	  };
	
	  this.destory = function () {
	    this.dom.removeEventListener('touchstart', this.handleTouchStart);
	    this.dom.removeEventListener('touchmove', this.handleTouchMove);
	    this.dom.removeEventListener('touchend', this.handleTouchEnd);
	  };
	
	  this.init();
	};

/***/ }),

/***/ 4:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(5),
	  /* template */
	  __webpack_require__(6),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _eventbus = __webpack_require__(2);
	
	var _eventbus2 = _interopRequireDefault(_eventbus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'btn',
	  props: {
	    name: {
	      type: String,
	      default: ''
	    },
	    theme: {
	      type: String,
	      default: 'default'
	    },
	    size: {
	      type: String,
	      default: 'default'
	    },
	    block: {
	      type: Boolean,
	      default: false
	    },
	    icon: {
	      type: String,
	      default: ''
	    },
	    disable: {
	      type: Boolean,
	      default: true
	    },
	    loading: {
	      type: Boolean,
	      default: false
	    },
	    submit: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    handleClick: function handleClick() {
	      if (this.submit !== '') {
	        _eventbus2.default.$emit('btn-submit', this.submit);
	      }
	      if (this.disable && !this.loading) {
	        this.$emit('on-click', '');
	      }
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('button', {
	    staticClass: "btn",
	    class: [
	      'btn-' + _vm.theme,
	      'btn-' + _vm.size,
	      _vm.block ? 'btn-block' : ''
	    ],
	    on: {
	      "click": _vm.handleClick
	    }
	  }, [(_vm.icon != '' && !_vm.loading) ? _c('i', {
	    staticClass: "icon iconfont",
	    class: [_vm.icon ? 'icon-' + _vm.icon : '']
	  }) : _vm._e(), _vm._v(" "), (_vm.loading) ? _c('i', {
	    staticClass: "icon iconfont icon-loading loading"
	  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.name))])])
	},staticRenderFns: []}

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(15),
	  /* template */
	  __webpack_require__(19),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _touchit = __webpack_require__(3);
	
	var _touchit2 = _interopRequireDefault(_touchit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Modal',
	  components: {},
	  props: {
	    mode: {
	      type: String,
	      default: 'swipeDown' }
	  },
	  created: function created() {
	    try {
	      this.pullDistance *= window.r || 1;
	    } catch (e) {
	      this.pullDistance *= 1;
	    }
	
	    this.touchit = new _touchit2.default({
	      dom: document.body,
	      type: this.mode,
	      done: this.loading,
	      doing: this.handleTouch
	    });
	  },
	
	  methods: {
	    reset: function reset() {
	      var _this = this;
	
	      setTimeout(function () {
	        _this.pullState = 0;
	      }, 300);
	
	      this.move(0);
	      this.isloading = false;
	    },
	    move: function move(distance) {
	      this.$refs.list.style.transform = 'translate(0px, ' + distance + 'px)';
	    },
	    loading: function loading() {
	
	      this.isloading = true;
	      this.pullState = 4;
	      this.distance = 0;
	      if (this.mode === 'swipeUp') {
	        this.move(-this.pullDistance);
	      }
	      if (this.mode === 'swipeDown') {
	        this.move(this.pullDistance);
	      }
	      this.$emit('on-loading', this);
	    },
	    handleTouch: function handleTouch(eventType, data) {
	      var _this2 = this;
	
	      switch (eventType) {
	        case 'touchstart':
	          {
	            break;
	          }
	        case 'touchmove':
	          {
	            var isRight = true;
	
	            if (Math.abs(this.distance) < this.pullDistance + 50) {
	              this.distance = data.distance.y;
	              this.move(this.distance);
	            }
	
	            switch (this.mode) {
	
	              case 'swipeUp':
	                {
	
	                  if (data.distance.y < 0) {
	                    isRight = true;
	                    this.pullState = 2;
	                  } else {
	                    isRight = false;
	                    this.pullState = 0;
	                  }
	                  break;
	                }
	              case 'swipeDown':
	                {
	                  if (data.distance.y > 0) {
	                    isRight = true;
	                    this.pullState = 1;
	                  } else {
	                    isRight = false;
	                    this.pullState = 0;
	                  }
	                  break;
	                }
	              default:
	                {
	                  break;
	                }
	            }
	
	            if (Math.abs(data.distance.y) > this.pullDistance && isRight) {
	              this.pullState = 3;
	            }
	
	            break;
	          }
	        case 'touchend':
	          {
	            this.distance = 0;
	
	            setTimeout(function () {
	              _this2.pullState = 0;
	            }, 300);
	
	            this.move(0);
	            break;
	          }
	        default:
	          {
	            break;
	          }
	      }
	    }
	  },
	  data: function data() {
	    return {
	      touchit: null,
	      isloading: false,
	      notice: ['', '下拉刷新列表', '上拉刷新列表', '松开刷新', '加载中'],
	      pullState: 0,
	      distance: 0,
	      pullDistance: 60
	    };
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.touchit.destory();
	  }
	};

/***/ }),

/***/ 19:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    ref: "list",
	    staticClass: "list-hack"
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.pullState > 0 && _vm.mode === 'swipeDown'),
	      expression: "pullState>0&&mode==='swipeDown'"
	    }],
	    staticClass: "down-fresh"
	  }, [_c('p', [_c('i', {
	    staticClass: "icon iconfont icon-loading",
	    class: [
	      _vm.isloading ? 'loading' : ''
	    ]
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.notice[_vm.pullState]))])])]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.pullState > 0 && _vm.mode === 'swipeUp'),
	      expression: "pullState>0&&mode==='swipeUp'"
	    }],
	    staticClass: "up-fresh"
	  }, [_c('p', [_c('i', {
	    staticClass: "icon iconfont icon-loading",
	    class: [
	      _vm.isloading ? 'loading' : ''
	    ]
	  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.notice[_vm.pullState]))])])]), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(125),
	  /* template */
	  __webpack_require__(261),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _menuVertical = __webpack_require__(13);
	
	var _menuVertical2 = _interopRequireDefault(_menuVertical);
	
	var _list = __webpack_require__(12);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _btn = __webpack_require__(4);
	
	var _btn2 = _interopRequireDefault(_btn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'menudemo',
	  components: {
	    menuVertical: _menuVertical2.default,
	    list: _list2.default,
	    btn: _btn2.default
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 261:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('list', {
	    staticClass: "list-box p0002"
	  }, [_c('li', {
	    staticClass: "list-item"
	  }, [_c('menu-vertical', {
	    attrs: {
	      "icon": "scan"
	    }
	  }, [_c('span', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v("带图标")])])], 1), _vm._v(" "), _c('li', {
	    staticClass: "list-item list-item-arrow"
	  }, [_c('menu-vertical', {
	    attrs: {
	      "icon": "cascades"
	    }
	  }, [_c('p', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v("带图标箭头")])])], 1)]), _vm._v(" "), _c('list', {
	    staticClass: "list-box p0002 m2000"
	  }, [_c('li', {
	    staticClass: "list-item"
	  }, [_c('menu-vertical', [_c('p', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v("右侧停靠")]), _vm._v(" "), _c('btn', {
	    attrs: {
	      "slot": "dock",
	      "theme": "blank",
	      "blank": "true",
	      "name": "Anything"
	    },
	    slot: "dock"
	  })], 1)], 1), _vm._v(" "), _c('li', {
	    staticClass: "list-item"
	  }, [_c('menu-vertical', [_c('p', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v("右侧停靠")]), _vm._v(" "), _c('i', {
	    staticClass: "icon iconfont icon-roundcheckfill",
	    staticStyle: {
	      "font-size": "24px",
	      "color": "#3492e6"
	    },
	    attrs: {
	      "slot": "dock"
	    },
	    slot: "dock"
	  })])], 1), _vm._v(" "), _c('li', {
	    staticClass: "list-item list-item-arrow"
	  }, [_c('menu-vertical', [_c('p', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v("自定义内容 "), _c('span', {
	    staticStyle: {
	      "display": "block",
	      "font-size": "13px",
	      "color": "#999"
	    }
	  }, [_vm._v("随便怎么加")])])])], 1)])], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.ca74cac3083377b270dc.js